/* Required jQuery initialization for select2 */
jQuery(document).ready(function($) {
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modalElement = document.querySelector('.custom-message-modal-overlay');
    const modalTitle = document.querySelector('.custom-message-modal-header h2');
    const modalCross = document.querySelector('.custom-message-modal-close');

    if (modalElement) {
        modalElement.addEventListener('click', function(e) { 
            if (e.target.classList.contains('changed')) {
                modalElement.classList.remove('d-flex');
                e.target.remove();  
            }
        });
    }

    $('#applicantStatus').on('change', function () {
        let confirmChange = document.querySelector('.custom-message-modal-btn.confirm');
        const applicantId = document.querySelector('#applicantId').value;
        const jobId = document.querySelector('#jobId').value;
        const newStatus = this.value;

        confirmChange.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmChange.setAttribute('data-applicant', applicantId);
        confirmChange.setAttribute('data-job', jobId);
        confirmChange.setAttribute('data-action', newStatus);
        confirmChange.setAttribute('data-confirm', 'applicant');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'Are you sure you want to update Applicant status ?';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }
    });

    let confirmChange = document.querySelector('.custom-message-modal-btn.confirm');
    if( confirmChange ) {
        confirmChange.addEventListener('click', function() {
            const applicantId = confirmChange.getAttribute("data-applicant");
            const jobId = confirmChange.getAttribute("data-job");
            const actionStatus = confirmChange.getAttribute("data-action");
            const changeStatus = confirmChange.getAttribute("data-confirm");
            if( changeStatus !== 'applicant' ) {
                return;
            }
            const modalBody = document.querySelector('.custom-message-modal-body p');
            if (modalBody) modalBody.textContent = 'Updating applicant status...';
            if (modalTitle) modalTitle.textContent = 'Please wait';

            if( modalElement ) modalElement.classList.add('processing');
            if( modalCross ) modalCross.style.display = 'none';
            confirmChange.style.display = 'none';
            confirmBtnCancel.style.display = 'none';

            console.log(actionStatus);

            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employer_change_applicant_status',
                    applicantid: applicantId,
                    jobid: jobId,
                    job_action: actionStatus,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    console.log(data)
                    modalBody.textContent = 'Applicant status updated successfully';
                    if (modalTitle) modalTitle.textContent = 'Confirmation';

                    window.location.reload(); 

                } else {
                    console.error('Failed to update applicant status.');
                    if (modalTitle) modalTitle.textContent = 'Attention required';
                    if (modalBody) modalBody.textContent = 'Failed to update applicant status.';
                    if( modalElement ) modalElement.classList.remove('processing');
                    if( modalCross ) modalCross.style.display = 'block';

                    const confirmButton = document.createElement('button');
                    confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs changed';
                    confirmButton.textContent = 'Ok';

                    const modalFooter = document.querySelector('.custom-message-modal-footer');
                    if (modalFooter) modalFooter.appendChild(confirmButton);
                }

            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        });
    }
});